import 'css-chunksrc/feature/check/CheckActivityTab.module.scss';export default {
  "root": "CheckActivityTab_root"
};